import { render } from "./PayResult.vue?vue&type=template&id=1c7a0cbe&ts=true"
import script from "./PayResult.vue?vue&type=script&lang=ts"
export * from "./PayResult.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__